import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { EngagementSpotlight } from '@atlassiansox/engagekit-ts';
import { defineMessages, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import EditIcon from '@atlaskit/icon/core/edit';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { SpotlightManager, SpotlightTarget } from '@atlaskit/onboarding';
import { N700 } from '@atlaskit/theme/colors';
import { DefinitionUpdateConfirmationFlag, EditDefinitionModal } from '../../v2/definitions/curated/edit-definition-modal';
import { useAIAnswerContext } from '../ai-answer-context';
import { onCuratedDefinitionEditButtonClicked, onCuratedDefinitionEditButtonShown } from '../analytics';
import { EditDefinitionWrapper } from '../styled';
var messages = defineMessages({
  edit_definition_icon_tooltip: {
    id: 'search_ai.curated-definition-edit-def-icon-tooltip',
    defaultMessage: 'Edit definition',
    description: 'Tooltip for edit definition icon'
  },
  edit_definition_prompt_text: {
    id: 'search_ai.edit_definition_prompt_text',
    defaultMessage: 'Not quite right? Edit this definition',
    description: 'Prompt text on button for users to edit a definition'
  }
});
var EditIconStyled = function EditIconStyled() {
  return /*#__PURE__*/React.createElement(EditIcon, {
    color: "var(--ds-icon-subtle, ".concat(N700, ")"),
    label: ""
  });
};
export var EditDefinition = function EditDefinition() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAIAnswerContext = useAIAnswerContext(),
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    isAnswered = _useAIAnswerContext.isAnswered,
    hasError = _useAIAnswerContext.hasError,
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions,
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _ref = readingAidsOptions || {},
    definitionCurationOptions = _ref.definitionCurationOptions;
  var editButtonSpotlightId = 'ai-definitions-edit-button';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEditModal = _useState2[0],
    setShowEditModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displaySuccessFlag = _useState4[0],
    setDisplaySuccessFlag = _useState4[1];
  var closeEditModal = useCallback(function () {
    return setShowEditModal(false);
  }, []);
  var openEditModal = useCallback(function () {
    fireAnalyticsEvent(onCuratedDefinitionEditButtonClicked(commonAttributes));
    setShowEditModal(true);
  }, [commonAttributes, fireAnalyticsEvent]);
  useEffect(function () {
    if (isAnswered) {
      fireAnalyticsEvent(onCuratedDefinitionEditButtonShown(commonAttributes));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Fragment, null, !hasError && /*#__PURE__*/React.createElement(SpotlightManager, null, /*#__PURE__*/React.createElement(SpotlightTarget, {
    name: editButtonSpotlightId
  }, /*#__PURE__*/React.createElement(EditDefinitionWrapper, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    iconBefore: EditIconStyled,
    onClick: openEditModal
  }, formatMessage(messages.edit_definition_prompt_text)))), /*#__PURE__*/React.createElement(EngagementSpotlight, {
    engagementId: editButtonSpotlightId
  })), /*#__PURE__*/React.createElement(ModalTransition, null, showEditModal && definitionCurationOptions && /*#__PURE__*/React.createElement(EditDefinitionModal, {
    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
    closeEditModal: closeEditModal,
    onSaveEditModal: function onSaveEditModal() {
      return setDisplaySuccessFlag(true);
    }
  })), displaySuccessFlag && /*#__PURE__*/React.createElement(DefinitionUpdateConfirmationFlag, {
    onDismissed: function onDismissed() {
      return setDisplaySuccessFlag(false);
    }
  }));
};